var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 18.3337C4.55797 18.3337 4.13404 18.1581 3.82148 17.8455C3.50892 17.5329 3.33333 17.109 3.33333 16.667V3.33366C3.33333 2.89163 3.50892 2.46771 3.82148 2.15515C4.13404 1.84259 4.55797 1.66699 4.99999 1.66699H11.6667C11.9305 1.66657 12.1917 1.71833 12.4354 1.8193C12.6791 1.92027 12.9005 2.06846 13.0867 2.25533L16.0767 5.24533C16.264 5.43158 16.4126 5.65312 16.5139 5.89713C16.6152 6.14114 16.6671 6.4028 16.6667 6.66699V16.667C16.6667 17.109 16.4911 17.5329 16.1785 17.8455C15.8659 18.1581 15.442 18.3337 15 18.3337H4.99999Z",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.66699V5.83366C11.6667 6.05467 11.7545 6.26663 11.9107 6.42291C12.067 6.57919 12.279 6.66699 12.5 6.66699H16.6667",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 7.5H6.66667",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.833H6.66667",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.167H6.66667",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTest);
export default __webpack_public_path__ + "static/media/ic_test.0e25d699382bd89ae5af3aa3a549496c.svg";
export { ForwardRef as ReactComponent };